export default __webpack_public_path__ + "static/media/html.87f3f64a.svg";